export interface UpdateEventPayload {
  summary: string;
  description: string;
  startDateTime?: string;
  endDateTime?: string;
  lessonId?: string;
}

export const UPDATE_EVENT_API = 'v1/google/update-event';
